import { ReactNode } from 'react';

export type HighlightedTextConfig = {
  text: string;
  highlight?: string;
};

export const HighlightedText = ({
  text,
  highlight,
}: HighlightedTextConfig): ReactNode => {
  // Early return if empty highlight or text provided, or if there is no matches
  if (
    !highlight ||
    !text ||
    text.toLocaleLowerCase().indexOf(highlight.toLocaleLowerCase()) === -1
  ) {
    return text;
  }
  const lowerText = text.toLocaleLowerCase();
  const lowerHighlight = highlight.toLocaleLowerCase();
  const highlightLen = lowerHighlight.length;
  const build = (startIndex: number): ReactNode[] => {
    const matchIndex = lowerText.indexOf(lowerHighlight, startIndex);
    if (matchIndex === -1) {
      return startIndex < text.length ? [text.substring(startIndex)] : [];
    }
    const before =
      matchIndex > startIndex ? [text.substring(startIndex, matchIndex)] : [];
    const matched = (
      <b>{text.substring(matchIndex, matchIndex + highlightLen)}</b>
    );
    const after = build(matchIndex + highlightLen);

    return [...before, matched, ...after];
  };
  return <>{build(0)}</>;
};
